import { type UseSuspenseQueryResult, useSuspenseQuery } from "@tanstack/react-query";
import { axiosClient } from "@wayflyer/auth-sdk";
import { ProductRequestSchemas } from "@wayflyer/api-types";
import { useCustomerAppConfig } from "@wayflyer/undercarriage";

export const FUNDS_REQUEST_INFO_QUERY_KEY = "funds-request-info";

export const useGetFundsRequestInfoQuery =
  (): UseSuspenseQueryResult<ProductRequestSchemas.FundsRequestInfoResponse> => {
    const {
      data: { customerDomain },
    } = useCustomerAppConfig();

    return useSuspenseQuery(getFundsRequestInfoQueryOptions(customerDomain));
  };

export const getFundsRequestInfoQueryOptions = (customerDomain: string) => {
  const url = `/${customerDomain}/product-request/api/funds-request-info`;

  return {
    queryKey: [FUNDS_REQUEST_INFO_QUERY_KEY, customerDomain],
    queryFn: () => axiosClient.get<ProductRequestSchemas.FundsRequestInfoResponse>(url),
    select: ({ data }): ProductRequestSchemas.FundsRequestInfoResponse => data,
  };
};
